import React from 'react';

import { useTranslation } from 'react-i18next';

import { Select } from '@weezevent/nacre';
import { GenericInput } from '../inputs/inputs';
import { translateLocale, capitalizeFirstLetter } from '../../../attendee/detail/components/utils';
import { Dropdown } from 'semantic-ui-react';
const LANGUAGES = ['fr-FR', 'en-GB', 'en-US', 'es-ES', 'ca-ES', 'it-IT', 'br', 'nl-NL', 'de-DE', 'eu'];

export const useTranslatedLanguages = (languagesList = null) => {
    const { i18n } = useTranslation();
    const languages = languagesList || LANGUAGES;
    return React.useMemo(() => {
        return languages.reduce((acc, language) => {
            const translated = capitalizeFirstLetter(translateLocale(i18n.language, language));

            acc.push({
                key: language,
                value: language,
                text: translated
            });
            return acc;
        }, []);
    }, [i18n.language]);
};

export function MultiLanguageSelector({ languages = [], onChange = () => {} }) {
    const { t } = useTranslation();

    const translated_languages = useTranslatedLanguages();

    return (
        <GenericInput label={t('ticket.widgets.event.config.languages_label')}>
            <Dropdown
                search
                selection
                multiple
                options={translated_languages}
                onChange={(synth, data) => {
                    onChange('languages', data.value);
                }}
                label={t('ticket.widgets.event.config.languages_label')}
                placeholder={t('ticket.widgets.event.config.languages_placeholder')}
                value={languages}
                fluid
            />
        </GenericInput>
    );
}

export function DefaultLanguageSelector({ language, onChange }) {
    const { t } = useTranslation();
    const translated_languages = useTranslatedLanguages();
    return (
        <GenericInput label={t('ticket.widgets.event.config.default_language_label')}>
            <Select
                useNew
                value={language}
                options={translated_languages}
                placeholder={t('ticket.widgets.event.config.default_language_placeholder')}
                onChange={value => {
                    onChange('default_language', value);
                }}
            />
        </GenericInput>
    );
}
